import { PrismicError } from "./PrismicError";

export class NotFoundError extends PrismicError<undefined> {}
